"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var brown = {
  1: '',
  2: '#DEAC5F',
  3: '#A86425',
  4: '#864E1B',
  5: ''
};
var _default = brown;
exports.default = _default;